<template>
  <div class="flatpickr-parent">
    <div class="flatpickr-mask" data-toggle>
      <span v-if="!formattedDate" class="mask-content placeholder"
        >{{ label.get("select_date") }}:</span
      >
      {{ formattedDate }}
    </div>
    <flat-pickr
      v-model="date"
      :config="config"
      :placeholder="label.get('select_date')"
      name="date"
      @on-close="onPickerClose"
      @on-open="onPickerOpen"
    />
  </div>
</template>

<script>
import "flatpickr/dist/flatpickr.css";

export default {
  name: "CompactDatepickerComponent",
  props: {
    initialDate: {
      type: String,
      default: undefined,
    },
    entryType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    let _this = this;
    return {
      date: this.initialDate
        ? this.$moment(this.initialDate).format("YYYY-MM-DD")
        : null,
      formattedDate: this.initialDate
        ? this.$moment(this.initialDate).format("MMM D")
        : null,
      applyButtonClicked: false,
      config: {
        inline: false,
        mode: "multiple",
        altInput: false,
        wrap: true,
        static: false,
        closeOnSelect: false,
        monthSelectorType: "static",
        yearSelectorType: "static",
        locale: this.getLocale(),
        //ignoredFocusElements: [document.body],
        onReady: function(dateObj, dateStr, instance) {
          let calendar = instance.calendarContainer;
          let utilities = document.createElement("div");
          utilities.setAttribute("class", "calendar-utilities");

          let checkBoxWrapper = document.createElement("div");
          checkBoxWrapper.setAttribute("class", "check-box-wrapper");

          let repeatLabel = document.createElement("label");
          repeatLabel.setAttribute("for", "mode");
          repeatLabel.innerText = _this.label.get("repeats");

          let okButton = document.createElement("BUTTON");
          okButton.innerHTML = _this.label.get("apply");
          okButton.setAttribute("class", "btn-apply");

          let clearButton = document.createElement("BUTTON");
          clearButton.innerHTML = _this.label.get("clear");
          clearButton.setAttribute("class", "btn-clear");

          let repeatsCheckbox = document.createElement("INPUT");
          repeatsCheckbox.setAttribute("type", "checkbox");
          repeatsCheckbox.setAttribute("id", "mode");
          repeatsCheckbox.setAttribute("class", "check-repeats");
          repeatsCheckbox.setAttribute("checked", "checked");

          checkBoxWrapper.appendChild(repeatsCheckbox);

          utilities.appendChild(checkBoxWrapper);
          utilities.appendChild(repeatLabel);
          utilities.appendChild(clearButton);
          utilities.appendChild(okButton);

          calendar.appendChild(utilities);

          okButton.addEventListener("click", function(event) {
            event.preventDefault();
            event.stopPropagation();
            if (_this.date !== null && _this.date !== "") {
              _this.applyButtonClicked = true;
              instance.close();
            }
          });
          clearButton.addEventListener("click", function(event) {
            event.preventDefault();
            event.stopPropagation();
            _this.applyButtonClicked = false;
            instance.clear();
          });
          repeatsCheckbox.addEventListener("change", function(event) {
            if (event.currentTarget.checked) {
              instance.config.mode = "multiple";
            } else {
              instance.config.mode = "single";
            }
            instance.clear();
          });
        },
      },
    };
  },
  watch: {
    date: function(newVal, oldVal) {
      this.formattedDate = "";
      if (newVal !== null && newVal !== "") {
        let dates = newVal.split(",");
        dates.forEach((date) => {
          this.formattedDate +=
            this.$moment(date.trim()).format("MMM D") + ", ";
        });
        this.formattedDate = this.formattedDate.substr(
          0,
          this.formattedDate.length - 2
        );
      }
    },
  },
  methods: {
    getLocale() {
      if (window.locale !== undefined && window.locale !== "en") {
        if (window.locale === "de") {
          const locale = require("flatpickr/dist/l10n/de.js");
          return locale.German;
        }
        if (window.locale === "fr") {
          const locale = require("flatpickr/dist/l10n/fr.js");
          return locale.French;
        }
        if (window.locale === "es") {
          const locale = require("flatpickr/dist/l10n/es.js");
          return locale.Spanish;
        }
      }
      return null;
    },
    onPickerClose() {
      if (!this.applyButtonClicked) {
        if (this.initialDate === undefined || this.initialDate === "") {
          this.date = null;
          this.formattedDate = null;
        } else {
          this.date = this.initialDate;
          this.formattedDate = this.$moment(this.initialDate).format("MMM D");
        }
      }
      this.$emit("onDateSelected", this.date);
    },
    onPickerOpen() {
      this.applyButtonClicked = false;
      if (this.entryType === 0) {
        this.$set(this.config, "maxDate", "today");
      } else {
        this.$set(this.config, "maxDate", null);
      }
    },
  },
};
</script>

<style lang="scss">
.flatpickr-calendar {
  padding: 24px;
  border: 0;
  border-radius: 0;
  box-shadow: 0 2px 10px rgba(38, 38, 38, 0.2);
  width: 330px;
  height: 420px;

  .dayContainer {
    min-width: 274px;
    width: 280px;
    height: 241px;
  }
}

.flatpickr-months {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  .flatpickr-prev-month,
  .flatpickr-next-month {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    width: 40px;
    height: 40px;
    border: 1px solid #efefef;
    z-index: 2;
    // Font Arrows
    font-size: 1rem;
    color: #c7c7c7;
    font-family: "attotime" !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    svg {
      display: none;
    }
  }
  .flatpickr-month {
    height: 24px;
    width: 100%;
    position: absolute;
    left: 0;
    top: 8px;
    z-index: 1;
  }

  .flatpickr-prev-month {
    &:before {
      content: "\E940";
    }
  }

  .flatpickr-next-month {
    margin-left: auto;
    &:before {
      content: "\E986";
    }
  }

  .flatpickr-current-month {
    padding: 0;
    margin: 0;
    width: 100%;
    left: auto;
    font-size: inherit;
    position: relative;
    height: 24px;
    .cur-year,
    .cur-month {
      font-size: 1.125rem;
      line-height: 1.5rem;
      font-family: "Roboto", sans-serif;
      font-weight: 500;
      color: #262626;
      &:hover {
        background-color: transparent;
      }
    }

    .numInputWrapper {
      width: 50px;
      margin-left: 5px;
      input {
        font-size: 1.125rem !important;
        line-height: 1.5rem !important;
        font-family: "Roboto", sans-serif !important;
        font-weight: 500 !important;
        color: #262626 !important;
        border: 0 !important;
        padding: 0 !important;
      }
      &:hover {
        background-color: transparent;
      }
      > .arrowUp,
      > .arrowDown {
        display: none;
      }
    }
  }
}

.flatpickr-weekdays {
  height: 40px;
  display: flex;
  flex-direction: row;
}

.flatpickr-days {
  width: 280px;
}

.flatpickr-weekdays .flatpickr-weekday,
.flatpickr-day {
  font-size: 0.875rem;
  padding: 0;

  font-family: $roboto-font;
  color: #262626;
  font-weight: 400;
  line-height: 39px;
  width: 40px;
  height: 40px;
  max-width: 40px;
  max-height: 40px;
  box-sizing: border-box;
  border-radius: 0;
  display: inline-table;
}

.dayContainer > span,
.dayContainer > span.flatpickr-disabled,
.dayContainer > span.prevMonthDay,
.dayContainer > span.nextMonthDay {
  border-right: 0;
  border-bottom: 0;
  border-left: 1px solid #efefef;
  border-top: 1px solid #efefef;
}

.dayContainer > span:nth-child(7n) {
  border-right: 1px solid #efefef;
}

.dayContainer > span:nth-last-child(-n + 7) {
  border-bottom: 1px solid #efefef !important;
}
.flatpickr-day.today:hover,
.flatpickr-day.nextMonthDay:hover,
.flatpickr-day.prevMonthDay:hover {
  background-color: transparent;
  border-color: #efefef;
}

.flatpickr-day {
  &:hover {
    background-color: #00b9cb;
    border-color: #00b9cb;
  }
}

.flatpickr-day.today {
  border-color: #efefef;
  font-weight: 500;
  &:hover {
    background-color: #00b9cb;
    border-color: #00b9cb;
  }
}

.flatpickr-day.today.inRange,
.flatpickr-day.inRange,
.flatpickr-day.prevMonthDay.selected,
.flatpickr-day.nextMonthDay.selected,
.flatpickr-day.selected {
  color: #fff;
  background-color: #00b9cb;
  border-color: #00b9cb;
  box-shadow: none;
}

.flatpickr-day.startRange,
.flatpickr-day.endRange {
  border-radius: 0 !important;
}
.flatpickr-day.selected:focus,
.flatpickr-day.selected:hover {
  background-color: #0a9ead;
  border-color: #0a9ead;
  box-shadow: none;
}

.flatpickr-weekday {
  color: #999999;
}

.rangeMode .flatpickr-day {
  margin-top: 0;
}
.flatpickr-parent {
  position: relative;
  .flatpickr-input {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
    width: 184px;
    height: 40px;
  }
}

.flatpickr-mask {
  border: 2px solid $atto-light-grey;
  padding: 8px;
  height: 40px;
  min-width: 192px;
  max-width: 454px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  position: relative;
  z-index: 2;
  cursor: pointer;

  font-size: 0.875rem;
  line-height: 1.25rem;
  font-family: $roboto-font;
  font-weight: 500;
  color: $atto-font-color;

  span.mask-content {
    display: block;
    &.placeholder {
      color: $atto-not-active;
    }
  }
  /* Font Styles */
}

.calendar-utilities {
  display: flex;
  flex-direction: row;
  margin-top: 24px;
  align-items: center;
  .check-box-wrapper {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    input[type="checkbox"] {
      -webkit-appearance: none;
      -moz-appearance: none;
      border: 2px solid #00b9cb;
      border-radius: 3px;
      width: 20px;
      height: 20px;
      position: relative;
      padding: 0 !important;

      &:focus {
        border-color: #efefef !important;
      }
    }
    input {
      background-color: #fff;
      &:after {
        display: none;
        font-family: "attotime" !important;
        content: "\E98F";
        color: #00b9cb;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        font-size: 18px;
        width: 20px;
        position: absolute;
        left: -1px;
        top: -1px;
      }
      &:checked {
        &:after {
          display: block;
        }
      }
    }
  }
  label {
    font-size: 0.875rem;
    line-height: 1.5rem;
    font-family: $roboto-font;
    font-weight: 500;
    color: $atto-font-color;
    margin-left: 10px;
    margin-bottom: 0;
  }
  .btn-clear {
    padding: 0;
    margin-left: auto;
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-family: $roboto-font;
    font-weight: 500;
    color: #c7c7c7;
    cursor: pointer;
    &:hover {
      color: #999999;
    }
  }
  .btn-apply {
    padding: 0;
    font-size: 1.125rem;
    line-height: 1.75rem;
    font-family: $roboto-font;
    font-weight: 500;
    color: $atto-green;
    cursor: pointer;
    margin-left: 24px;
    &:hover {
      color: #0a9ead;
    }
  }
}
</style>
